import { render, staticRenderFns } from "./ProjectRequestModal.vue?vue&type=template&id=3a8d8f49&scoped=true&"
import script from "./ProjectRequestModal.vue?vue&type=script&lang=js&"
export * from "./ProjectRequestModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectRequestModal.vue?vue&type=style&index=0&id=3a8d8f49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8d8f49",
  null
  
)

export default component.exports